/**
 * Client che chiama la nostra serverless function /api/ask.
 * La chiave Gemini NON e' visibile in questo file ne' nel browser:
 * tutto succede sul server. In dev locale, il middleware Vite emula
 * /api/ask leggendo GEMINI_API_KEY da .env.
 *
 * Il parametro `locale` istruisce il server su quale lingua usare per la
 * risposta del modello (system instruction "Reply in <language>"). Se non
 * specificato, il server fa fallback a italiano.
 *
 * Su Capacitor (iOS/Android) il `fetch` con path relativo "/api/ask"
 * non funziona perche' il bundle e' servito da `capacitor://` o `https://localhost`
 * (no backend nello stesso origin). In quel caso usiamo un URL assoluto
 * verso il deploy Vercel via VITE_API_BASE_URL (in .env.production).
 */
const API_BASE_URL: string =
  (typeof import.meta !== "undefined" && (import.meta as any).env?.VITE_API_BASE_URL) || "";

export const askGemini = async (
  context: string,
  question: string,
  locale?: string
): Promise<string> => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/ask`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ context, question, locale }),
    });

    if (!res.ok) {
      const data = await res.json().catch(() => null);
      const msg = data?.error ?? `Errore ${res.status}`;
      console.warn("Risposta /api/ask non ok:", msg);
      if (res.status === 500) {
        return "Chiave API non configurata sul server. Imposta GEMINI_API_KEY in .env (locale) o nelle impostazioni Vercel (produzione).";
      }
      return "Spiacente, non riesco a rispondere in questo momento. Riprova piu' tardi.";
    }

    const data = (await res.json()) as { answer?: string };
    return data.answer ?? "";
  } catch (err) {
    console.error("Errore di rete /api/ask:", err);
    return "Spiacente, non riesco a contattare il server. Controlla la connessione e riprova.";
  }
};
